import { makeStyles, theme } from '@focaldata/cin-ui-components'

export const useStyles = makeStyles()({
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
    minWidth: 0
  },
  labels: {
    display: 'flex',
    flex: '1 1 240px',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0
  },
  identity: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    maxWidth: '100%'
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    minHeight: theme.spacing(4.5),
    marginLeft: 'auto',
    maxWidth: '100%',
    minWidth: 0
  },
  chip: {
    // Match the design-system SecondaryOutlined button used by existing chips.
    borderRadius: theme.spacing(0.25),
    textTransform: 'none',
    minHeight: theme.spacing(4.5),
    height: 'auto',
    minWidth: 0,
    maxWidth: '100%',
    flexShrink: 0,
    '& .MuiButton-startIcon': { flexShrink: 0 }
  },
  informational: {
    cursor: 'default',
    '&:hover': { backgroundColor: 'transparent' }
  },
  label: {
    fontWeight: theme.typography.fontWeightRegular,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    textAlign: 'left',
    minWidth: 0
  }
})
